export default __webpack_public_path__ + "static/media/ISMO CLASS-10 EXAM PATTERN 2026-27.46e99bfd.pdf";